<div class="scrollable-component">
	<p-panel header="Generic Mapper Types">
		<div class="form-group row">
			<label class="col-sm-2 col-form-label">Select an Integration</label>
			<div class="col-sm-10">
				<p-dropdown
					[options]="integrations"
					[(ngModel)]="selectedIntegration"
					optionLabel="name"
					optionValue="id"
					(onChange)="selectIntegration($event)"
				>
				</p-dropdown>
			</div>
		</div>
		<p-tabView>
			<p-tabPanel header="Product Types">
				<cv-generic-editable-table
					[integrationId]="selectedIntegration"
					[label]="'Product Type'"
					[entity]="'product-types'"
					[model]="productTypeModel"
				>
				</cv-generic-editable-table>
			</p-tabPanel>
			<p-tabPanel header="Mappers">
				<div class="form-group row">
					<label class="col-sm-2 col-form-label">Choose Mapper Type</label>
					<div class="col-sm-10">
						<p-dropdown
							[options]="mappers"
							[(ngModel)]="selectedMapper"
							optionLabel="name"
							optionValue="id"
							(onChange)="onSelectMapper($event)"
						>
						</p-dropdown>
					</div>
				</div>
					<cv-generic-mapper-types
						*ngIf="selectedMapper"
						[integrationId]="selectedIntegration"
						[entity]="selectedMapper"
					>
					</cv-generic-mapper-types>
			</p-tabPanel>
			<p-tabPanel header="Document Types">
				<cv-generic-document-types
					[integrationId]="selectedIntegration"
					[label]="'Document Type'"
					[entity]="'document-types'"
				>
				</cv-generic-document-types>
			</p-tabPanel>
			<p-tabPanel header="Default Settings">
				<cv-generic-default-settings
					[integrationId]="selectedIntegration"
				>
				</cv-generic-default-settings>
			</p-tabPanel>
			<p-tabPanel header="Organizations">
				<cv-generic-editable-table
					[integrationId]="selectedIntegration"
					[label]="'Organizations'"
					[entity]="'Organizations'"
					[model]="organizationModel"
				>
				</cv-generic-editable-table>
			</p-tabPanel>
		</p-tabView>
	</p-panel>
</div>